import React, { Component, useRef } from "react";
import logo from "./logo.svg";
import "./App.css";
import PatioFinder from "./components/PatioFinder/PatioFinder.js";
import useWindowDimensions from "./utils/useWindowDimensions.js";

function App() {
  const { height, width } = useWindowDimensions();
  return (
    <div className="App">
      <PatioFinder innerWidth={width} />
    </div>
  );
}

export default App;
